import { useEffect } from 'react'
import Main2FAFlow from './main-flow'
import { StokrLoader } from '@stokr/components-library'
import { navigateToAppUrl } from 'shared/utils/app-urls'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuthSession } from 'shared/context/AuthContext'
import { hasLoggedInSession } from 'shared/utils/user-identity'
import { getSetup2faReturnUrl, SETUP_2FA_PATH, type LoginLocationState } from 'shared/utils/login-redirect'

/**
 * Shared 2FA enrolment modal for `/setup-2fa`, rendered over the homepage like `/login`.
 * Remotes (`/dashboard`, `/admin`, …) redirect here with `state.redirectUrl` when their
 * `ProtectedRoute` finds no MFA enrolment, and the user lands back on that page afterwards.
 */
export const Setup2FAFlow = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { user, isFetchingUser, userMfaEnrollment, checkMfaEnrollment } = useAuthSession()

  const isLoggedIn = hasLoggedInSession(user)
  const returnUrl = getSetup2faReturnUrl(location.state as LoginLocationState | null)
  const hasMfaEnabled = Array.isArray(userMfaEnrollment) && userMfaEnrollment.length > 0

  useEffect(() => {
    if (isFetchingUser) return
    if (!isLoggedIn) {
      // Log in first, then come back here to enrol.
      navigate('/login', { replace: true, state: { redirectUrl: SETUP_2FA_PATH } })
    }
  }, [isFetchingUser, isLoggedIn, navigate])

  useEffect(() => {
    if (isLoggedIn && userMfaEnrollment == null) checkMfaEnrollment()
  }, [isLoggedIn, userMfaEnrollment, checkMfaEnrollment])

  useEffect(() => {
    if (hasMfaEnabled) navigateToAppUrl(returnUrl, navigate, { replace: true, state: null })
  }, [hasMfaEnabled, returnUrl, navigate])

  if (!isLoggedIn || userMfaEnrollment == null) return <StokrLoader />

  return (
    <Main2FAFlow
      open2faflow
      title=""
      subtitle=""
      showSwitch={false}
      showInlineLoginOnLogout={false}
      onFlowClose={(event) => {
        const completed = typeof event === 'object' && event.completed
        if (!completed) navigate('/', { replace: true, state: null })
      }}
      onLoginAgainClick={() => navigate('/login', { replace: true, state: { redirectUrl: SETUP_2FA_PATH } })}
    />
  )
}

export default Setup2FAFlow
